import { TablePagination } from '@octano/global-ui';
import { useStudentsRemovalRequestHistoryList } from './StudentsRemovalRequestHistoryListLoader';

export interface PerformanceAnalysisTablePaginationProps {
  total: number;
  totalPages: number;
}

export function StudentsRemovalRequestHistoryTablePagination({
  total,
  totalPages,
}: PerformanceAnalysisTablePaginationProps) {
  const { query, updateQuery } = useStudentsRemovalRequestHistoryList();

  return (
    <TablePagination
      pagination={{
        currentPage: query.page,
        itemsPerPage: 10,
        onChangePage: (page) => {
          updateQuery({ ...query, page });
        },
        totalItems: total,
        totalPages: totalPages,
      }}
    />
  );
}
